module.exports = __webpack_public_path__ + "8f47d09b6f2762073df3030f81e8c40b.jpg";